export default __webpack_public_path__ + "static/media/linx.c597b942.png";